/** Варіанти значення поля для рядка розширених фільтрів: статуси типу для поля `status`, інакше варіанти поля. */
import type { IFieldDefinition, IRecordTypeDefinition, ModuleStringFallback } from '@platform/core/types';

/** Значення та підпис визначення (для резолвера рядків модуля) кожного варіанта. Чиста функція. */
export function fieldOptions(rt: IRecordTypeDefinition, field: IFieldDefinition | undefined): { value: string; label: ModuleStringFallback }[] {
  if (!field) return [];
  if (field.key === 'status' && rt.statuses.list.length) return rt.statuses.list.map((s) => ({ value: s.value, label: s.label }));
  return (field.options ?? []).map((o) => ({ value: o.value, label: o.label ?? null }));
}
